package org.teddapp.project.db.repo

import com.tedd.db.TeddDatabase
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.withContext

/**
 * Accès aux préférences locales (thème, langue, etc.). Table app_preference
 * en mode key-value. Ne synchronise PAS vers Supabase — chaque appareil garde
 * ses propres préférences (cohérent avec l'UX où chaque écran a son thème).
 */
class PreferencesRepository(private val db: TeddDatabase) {

    suspend fun get(key: String): String? = withContext(Dispatchers.Default) {
        db.appPreferenceQueries.getValue(key).executeAsOneOrNull()
    }

    suspend fun set(key: String, value: String) = withContext(Dispatchers.Default) {
        db.appPreferenceQueries.setValue(key, value)
    }

    suspend fun loadAll(): Map<String, String> = withContext(Dispatchers.Default) {
        db.appPreferenceQueries.selectAll().executeAsList().associate { it.key to it.pref_value }
    }

    suspend fun delete(key: String) = withContext(Dispatchers.Default) {
        db.appPreferenceQueries.deleteValue(key)
    }
}
